import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/ungdomgrupper',
    name: 'UngdomGrupper',
    component: () => import('./views/UngdomGrupper.vue')
  },
  {
    path: '/ungdomgrupper/ungdomgruppe/:id',
    name: 'UngdomGruppe',
    props: false,
    component: () => import('./components/UngdomGruppe.vue')
  },
  {
    path: '/ungdomgrupper/ungdomgruppe/:id/medlemmer',
    name: 'UngdomGruppeMedlemmer',
    props: false,
    component: () => import('./components/UngdomGruppeMedlemListe.vue')
  }
]
export default routes
